import { Breakpoint } from '../shared/stylesheet/Breakpoint'
import {
  BP_LARGE,
  BP_LARGE_MAX,
  BP_MEDIUM,
  BP_MEDIUM_MAX,
  BP_SMALL,
  BP_XLARGE,
  BP_XLARGE_MAX,
  BP_XXLARGE,
  BP_XXLARGE_MAX,
  BP_XXXLARGE,
  BP_XXXLARGE_MAX,
} from '../shared/stylesheet/Breakpoints'

export const MEDIUM_PIXELS = 768
export const LARGE_PIXELS = 1280
export const XLARGE_PIXELS = 1440
export const XXLARGE_PIXELS = 1920
export const XXXLARGE_PIXELS = 2560

export const breakpoints = {
  [BP_SMALL]: new Breakpoint(BP_SMALL, null, MEDIUM_PIXELS - 1),
  [BP_MEDIUM]: new Breakpoint(BP_MEDIUM, MEDIUM_PIXELS),
  [BP_LARGE]: new Breakpoint(BP_LARGE, LARGE_PIXELS),
  [BP_XLARGE]: new Breakpoint(BP_XLARGE, XLARGE_PIXELS),
  [BP_XXLARGE]: new Breakpoint(BP_XXLARGE, XXLARGE_PIXELS),
  [BP_XXXLARGE]: new Breakpoint(BP_XXXLARGE, XXXLARGE_PIXELS),
  [BP_MEDIUM_MAX]: new Breakpoint(BP_MEDIUM_MAX, null, MEDIUM_PIXELS - 1),
  [BP_LARGE_MAX]: new Breakpoint(BP_LARGE_MAX, null, LARGE_PIXELS - 1),
  [BP_XLARGE_MAX]: new Breakpoint(BP_XLARGE_MAX, null, XLARGE_PIXELS - 1),
  [BP_XXLARGE_MAX]: new Breakpoint(BP_XXLARGE_MAX, null, XXLARGE_PIXELS - 1),
  [BP_XXXLARGE_MAX]: new Breakpoint(BP_XXXLARGE_MAX, null, XXXLARGE_PIXELS - 1),
}
